(function(){
    'use strict';

    $(window).on('load', function() {

        /* 
            Standard debounce function, basically an advanced setTimeout 
        */
        function debounce(func, wait) {          

            var timeout;
            return function(){
                var context = this, args = arguments;
                if(timeout == null){
                    timeout = setTimeout(function() {
                        timeout = null;
                        func.apply(context, args);
                    }, wait);
                }
            }
        }

        function isMobile() {        
            return window.getComputedStyle(document.body).zIndex === "1";
         }

        /* Adds class to add margin to element at the bottom of previous step */
        function addBottomMarginToElementAbove(){
            var allSteps = document.querySelectorAll('.bq__ct__timeline-step');
            allSteps.forEach((element, index) => {
                if(index != 0){
                    var prevSibling = element.previousElementSibling;
                    
                    prevSibling.classList.add("bq__ct__timeline-step__added-this-bottom-margin");
                }
            //bq__ct__wrapper
            });
            
        }

        /* 
            Sets the initial step line height for all but the last step, 
            based on distance (in pixels) between the current and next step
        */
        function setInitialStepLineHeight() {
            $('.bq__ct__timeline-step').each(function(index) {
                var $this = $(this);
                var $nextStep = $('.bq__ct__timeline-step').eq(index + 1);
                // var lineOffset = index > 0 && index % 2 === 0 ? 84 : 54;
                var lineOffset = 54;

                if($nextStep.length) {
                    var stepLineHeight =
                        parseInt($nextStep.find('.bq__ct__column').position().top) -
                        parseInt($this.find('.bq__ct__column').position().top) -
                        lineOffset;
                    $this.find('.bq__ct__timeline-step__line').height(stepLineHeight);
                }
            })
        }

        function increaseStepLineheight() {
            var top = $(window).scrollTop();
            var dynamicWindowHeight = Math.abs($(window).height() / 5);
            if(dynamicWindowHeight > 400){
                dynamicWindowHeight = 400;
            }else if(dynamicWindowHeight < 170){
                dynamicWindowHeight = 170;
            }
           

            $('.bq__ct__timeline-step').each(function() {
                var $this = $(this);
                var $stepLine = $this.find('.bq__ct__timeline-step__line');
                var maxHeight = $stepLine.height();
                var $stepFiller = $stepLine.find('.bq__ct__timeline-step__line__filler');
                var $header = $this.find('.bq__ct__timeline-step__header');
                //Y pos on the screen we want to trigger the step
                //console.log(">" , dynamicWindowHeight , $this.css("padding-top"));
                var p_top = $this.css("padding-top");
                
                var triggerPoint;
                
                if(isMobile()){
                    triggerPoint = 100;
                }else{
                    triggerPoint = p_top == "0px" ? dynamicWindowHeight + 32 : dynamicWindowHeight;
                }


                //var triggerPoint = dynamicWindowHeight;

                //Top Y position of element to broswer
                var currentScreenYPos = $this.offset().top - top;  
                //height we want to set the line to - 40 is to offset it slightly 
                var heightToSetLine = triggerPoint - currentScreenYPos ;    

                // set the max-height for each step so there is no weird visual of overlap 
                $stepFiller.css({'max-height': `${maxHeight}px`});


                //if the current Ypos to Browser has passed the trigger point add the current step to the number
                if(currentScreenYPos !== 0 && currentScreenYPos < triggerPoint){
                    if(!$header.hasClass('bq__ct__timeline-step__header--current')){
                        $header.addClass('bq__ct__timeline-step__header--current');

                        //if we arent animating from a sticky nav click
                        if(squiz.vars.scrollingFromNavClick !== true){
                            //set the active state of the links in the header
                            var headerLinkToSetActive = $.find('[data_anchorid="'+ $header.prop('id') +'"]');
                            $('.bq__ct__anchor-links__item').removeClass('active');
                            $(headerLinkToSetActive).addClass('active');
                        }
                        
                    }
                }else{
                    if($header.hasClass('bq__ct__timeline-step__header--current')){
                        $header.removeClass('bq__ct__timeline-step__header--current');


                        //if we arent animating from a sticky nav click
                        if(squiz.vars.scrollingFromNavClick !== true){
                            //set the active state of the links in the header
                            var links = $('.bq__ct__anchor-links__item');
                            links.removeClass('active');
                            var headerLinkToSetActive = $.find('[data_anchorid="'+ $header.prop('id') +'"]');                        
                            var indexOfCurrent = links.index($(headerLinkToSetActive)) - 1;
                           
                            if(indexOfCurrent >= 0){
                                $(links[indexOfCurrent]).addClass('active');
                            }
                        }
                    }
                    
                }

                

                //if we are between the bound where we want to set the height of the line
                if(heightToSetLine >= 0 && heightToSetLine <= maxHeight){
                    $stepFiller.height(heightToSetLine);
                }else if(heightToSetLine < 0) {
                    // set the height to 0 to make sure it isn't shown
                    if($stepFiller.height() != 0){
                        $stepFiller.height(0);
                    }
                    
                } else if(heightToSetLine > maxHeight){
                    // set the height to max to make sure it fills whole line
                    if($stepFiller.height() != maxHeight){
                        $stepFiller.height(maxHeight);
                    }
                }
            });
        }
        
        function setCurrentHighlightedNavItem($header){
            
        }

        var debounceStepLineHeight = debounce(increaseStepLineheight, 100);

        if($('.bq__ct__timeline-step__line').length > 0) {
            addBottomMarginToElementAbove();
            setInitialStepLineHeight();
            $(window).on('resize', setInitialStepLineHeight);
            $(window).on('resize scroll', debounceStepLineHeight);
            
            increaseStepLineheight();
        }
    });
}());
